module.exports = __webpack_public_path__ + "37ba7b92/img/lock-icon.bb9c7166.svg";